import React, { FC, useEffect, useState } from "react";
import { DoctorsContainerParams } from "./DoctorsContainerParams.csharp";
import { TreatmentKeywordFilter } from "../ServicesContainer/TreatmentKeywordFilter";
import { TreatmentLocationFilter } from "../ServicesContainer/TreatmentLocationFilter";
import { filterByKeyword, filterByLocations } from "./doctorsContainerFilters";
import { TreatmentsContainerLocation } from "../ServicesContainer/TreatmentsContainerLocation.csharp";
import { DoctorsContainerList } from "./DoctorsContainerList";
import { HeadingWithBreakpoints } from "../Heading/HeadingWithBreakpoints";

export const DoctorsContainer: FC<DoctorsContainerParams> = ({
  heading,
  subheading,
  intro,
  iconUrl,
  linkDto,
  labels,
  doctors,
  locations,
}) => {
  const [selectedLocations, setSelectedLocations] = useState<
    TreatmentsContainerLocation[]
  >([]);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const selected = locations
      .flatMap((l) => [l, ...l.centers])
      .filter((l) => l.isPreselected);
    setSelectedLocations(selected);
  }, []);

  const getFilteredDoctors = () => {
    return filterByKeyword(
      filterByLocations(doctors, selectedLocations),
      keyword
    );
  };

  const onKeywordChange = (keyword: string) => {
    setKeyword(keyword);
  };

  const onLocationsChange = (locations: TreatmentsContainerLocation[]) => {
    setSelectedLocations(locations);
  };

  return (
    <>
      <div className="hero theme-inherit mb-4">
        {iconUrl ? (
          <>
            <div className="hero__media theme-inherit-medium d-none d-md-flex justify-content-center align-items-center">
              <img src={iconUrl} alt="" className="hero__media-icon" />
            </div>
          </>
        ) : (
          <div className="hero__media hero__media--no-image theme-inherit-medium"></div>
        )}

        <div className="hero__text-container">
          <div
            className="hero__text-container-inner theme-inherit-hero-light"
            style={{ height: "100%" }}
          >
            <h1 className="hero__heading mb-0">
              {heading && (
                <span className="main">
                  <HeadingWithBreakpoints
                    heading={heading.replace("|", "\u00AD")}
                  />
                </span>
              )}
              {subheading && <span className="fw-normal">{subheading}</span>}
            </h1>
          </div>
        </div>

        {intro && (
          <div className="container-fluid mt-n3">
            <div className="offset-lg-up">
              <div className="body-text-container mb-3 mb-md-4 lead">
                <div dangerouslySetInnerHTML={{ __html: intro }} />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="container-fluid">
        <div className="offset-lg-up">
          <div className="row mb-3">
            <div className="col-sm-9 col-lg-6">
              <TreatmentKeywordFilter
                onChange={onKeywordChange}
                keyword={keyword}
                placeholder={labels.searchPlaceholder}
              />
            </div>
            <div className="col-sm-9 col-lg-6">
              <TreatmentLocationFilter
                availableLocations={locations}
                selectedLocations={selectedLocations}
                onChange={onLocationsChange}
                selectAllLabel={labels.allLocationsLabel}
                selectLocationsLabel={labels.selectLocationsLabel}
              />
            </div>
          </div>

          <h2 className="h5">
            <a
              className="link-list--bare-bones__heading theme-border my-3"
              href={linkDto.url}
            >
              <span>{linkDto.title}</span>
            </a>
          </h2>
        </div>
      </div>

      <DoctorsContainerList doctors={getFilteredDoctors()} />
    </>
  );
};
